/**
 * Environment utility functions
 */

/**
 * Get the current environment from the API URL
 */
export const getEnvironment = () => {
  const apiUrl = import.meta.env.VITE_API_URL || 'http://localhost:8080';
  
  if (apiUrl.includes('localhost') || apiUrl.includes('127.0.0.1')) {
    return 'dev';
  }
  
  if (apiUrl.includes('staging')) {
    return 'staging';
  }
  
  return 'production';
};

/**
 * Get the environment-specific title prefix
 */
export const getEnvironmentPrefix = () => {
  const env = getEnvironment();
  
  switch (env) {
    case 'dev':
      return '[DEV] ';
    case 'staging':
      return '[STAGING] ';
    default:
      return '';
  }
};

/**
 * Set the document title with environment prefix
 */
export const setTitle = (title = 'Read It Never') => {
  const prefix = getEnvironmentPrefix();
  document.title = `${prefix}${title}`;
};

/**
 * Get environment-specific styling classes
 */
export const getEnvironmentClasses = () => {
  const env = getEnvironment();
  
  switch (env) {
    case 'dev':
      return 'border-t-4 border-green-500';
    case 'staging':
      return 'border-t-4 border-yellow-500';
    default:
      return '';
  }
};